
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 15c.531 0 1-.438 1-1V6H9.5A1.48 1.48 0 018 4.5V1H4c-.563 0-1 .469-1 1v12c0 .563.438 1 1 1h8zM9.5 5h3.469c-.031-.063-.063-.156-.125-.219L9.219 1.156c-.063-.062-.156-.093-.219-.125V4.5c0 .281.219.5.5.5zM4 0h4.875c.375 0 .781.188 1.063.469l3.593 3.594c.281.28.469.687.469 1.062V14c0 1.125-.906 2-2 2H4c-1.125 0-2-.875-2-2V2c0-1.094.875-2 2-2zm0 2.5c0-.25.219-.5.5-.5h2c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-2a.494.494 0 01-.5-.5zm0 2c0-.25.219-.5.5-.5h2c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-2a.494.494 0 01-.5-.5zm5 9c0-.25.219-.5.5-.5h2c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-2a.494.494 0 01-.5-.5zm2-3v-2H5v2h6zm-6-3h6c.531 0 1 .469 1 1v2c0 .563-.469 1-1 1H5c-.563 0-1-.438-1-1v-2c0-.531.438-1 1-1z","fill":"#212121"}})])
          )
        }
      }
    